import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { TABLE_EMPTY_VALUE, allMedicalConditions } from 'constants/constants';

const getConditionCodeFromKey = (key: string) => {
  const condition = allMedicalConditions.find((c) => c.description === key);
  return condition?.code || '';
};

const ConditionsView = ({ data }: { data: IMonitorDataPatient | ITaskPatientInfo }) => {
  const { formatMessage } = useIntl();
  let returnEl: JSX.Element | string | null = null;
  const conditions = data?.conditions || [];
  if (conditions.length > 1) {
    returnEl = (
      <OverlayTrigger
        placement="auto"
        overlay={
          <Tooltip id="tooltip-conditions">
            {conditions.map((condition: ICondition) => (
              <p key={condition.condition} className="m-0">
                - {formatMessage({ id: condition.condition })} -{' '}
                {getConditionCodeFromKey(condition.condition)}
              </p>
            ))}
          </Tooltip>
        }
      >
        <p className="m-0">{formatMessage({ id: conditions[0].condition })} ...</p>
      </OverlayTrigger>
    );
  } else {
    returnEl = conditions.length
      ? formatMessage({ id: conditions[0].condition })
      : TABLE_EMPTY_VALUE;
  }
  return (
    <div
      data-test={`patient-conditions-${data.uid}`}
      data-test-value={
        conditions.length
          ? conditions.map((condition: ICondition) => condition.condition).join(',')
          : TABLE_EMPTY_VALUE
      }
    >
      {returnEl}
    </div>
  );
};

export default ConditionsView;
